import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export type SubscriptionTier = 'CURVA' | 'LATERALE_DISTINTI' | 'CENTRALE_VIP' | 'POLTRONISSIMA';

export const SUBSCRIPTION_TIER_LABELS: Record<SubscriptionTier, string> = {
  CURVA: 'Curva (170 pt)',
  LATERALE_DISTINTI: 'Tribuna laterale / Distinti (340 pt)',
  CENTRALE_VIP: 'Tribuna centrale VIP (510 pt)',
  POLTRONISSIMA: 'Poltronissima (680 pt)',
};

export interface AwardResult {
  awarded: boolean;
  points: number;
  totalPoints: number;
}

export function useAwardSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { userId: string; tier: SubscriptionTier; season?: string }) => {
      const res = await apiClient.post<AwardResult>(`/loyalty/users/${vars.userId}/subscription`, {
        tier: vars.tier,
        season: vars.season,
      });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useAwardTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { userId: string; matchId?: string; note?: string }) => {
      const res = await apiClient.post<AwardResult>(`/loyalty/users/${vars.userId}/ticket`, {
        matchId: vars.matchId,
        note: vars.note,
      });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}
